import React from 'react';
export function ArticleHeader() {
  return <header className="mb-10" data-id="element-1">
      <div className="mb-6 flex items-center gap-2 text-sm font-sans text-brand-600 font-semibold uppercase tracking-wider" data-id="element-2">
        <span className="w-2 h-2 rounded-full bg-brand-600" data-id="element-3"></span>
        Beauté & Bien-être
      </div>

      <h1 className="text-3xl md:text-4xl lg:text-5xl font-sans font-extrabold text-gray-900 leading-tight mb-6" data-id="element-4">
        Découvrez pourquoi des milliers de femmes françaises retrouvent enfin
        une peau plus lisse et une silhouette plus harmonieuse… grâce à un
        simple rituel de 5 minutes par jour.
      </h1>

      <h2 className="text-xl md:text-2xl font-serif text-gray-600 italic mb-8 leading-relaxed" data-id="element-5">
        Une approche douce et réaliste pour les femmes qui en ont assez des
        fausses promesses, des traitements douloureux et des résultats qui ne
        durent jamais.
      </h2>

      <div className="flex items-center gap-4 mb-8 py-4 border-y border-gray-100" data-id="element-6">
        <img src="https://randomuser.me/api/portraits/women/32.jpg" alt="Claire Dubois" className="w-12 h-12 rounded-full object-cover" data-id="element-7" />
        <div className="font-sans" data-id="element-8">
          <div className="font-bold text-gray-900" data-id="element-9">Par Claire Dubois</div>
          <div className="text-sm text-gray-500" data-id="element-10">
            Publié le 12 Mai 2024 • 6 min de lecture
          </div>
        </div>
      </div>

      <img src="https://cdn.magicpatterns.com/uploads/pCVm6cUsBKkKWMqtHt3L9v/hf_20260313_161611_2a111fcd-7291-4da6-89a6-c0f0a81586bd.jpg" alt="Femme dans une cabine d'essayage" className="w-full h-auto rounded-2xl shadow-md mb-10 object-cover" data-id="element-11" />
    </header>;
}